import script from "./UserForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserForm.vue?vue&type=script&lang=ts&setup=true"

import "./UserForm.vue?vue&type=style&index=0&id=b2a408a0&lang=css"

export default script